import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import Dialog from 'material-ui/Dialog';
import locale from '../../common/locale'
import Cookies from 'universal-cookie';
import { isMobile } from 'react-device-detect';

const cookies = new Cookies();

export class MobileDialog extends Component {

  constructor(props) {
    super(props);
    this.state = { open: false }
  }

  componentDidMount() {
    if (isMobile) {
      this.setState({ open: true })
    }
  }

  handleClose = () => {
    this.setState({open: false});
  }

  render() {
    const loc = cookies.get('locale')
    return(
      <MuiThemeProvider>
        <Dialog
          modal={false}
          open={this.state.open}
          contentStyle={customContentStyle}
          onRequestClose={this.handleClose} >
          {locale.mobile_alert(loc)} <br />
          {locale.mobile_alert2(loc)}
        </Dialog>
      </MuiThemeProvider>
    )
  }
}

const customContentStyle = {
    width: '100%',
    maxWidth: 'none',
};

export default MobileDialog;



// WEBPACK FOOTER //
// ./src/components/nodes/MobileDialog.js